import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const ParcelLIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.57 1.143a1 1 0 0 1 1.036.004l7.916 4.85A1 1 0 0 1 21 6.85v10.105a1 1 0 0 1-.485.858l-8.084 4.85a1 1 0 0 1-1.037-.005l-7.916-4.85A1 1 0 0 1 3 16.955V6.85a1 1 0 0 1 .486-.857zM5 8.636l5.916 3.625v7.759L5 16.395zm7.916 11.403L19 16.39V8.616l-6.084 3.65zm-.994-9.508 6.15-3.69-2.035-1.246-6.15 3.69zM7.964 8.106l6.15-3.69-2.036-1.247-6.15 3.69z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
